import {contentFeedsApi} from 'common/src/modules/contentFeeds/contentFeeds.api';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {CampaignSetupAgentToolName} from '../../campaignSetupAgent.enums';

// Tool schema
const getContentFeedColumnsToolSchema = z.object({
  contentFeedId: z.number().describe('The content feed ID to get available columns for'),
});

function getContentFeedColumnsTool() {
  async function execute({
    input: {contentFeedId},
  }: ToolExecuteParams<typeof getContentFeedColumnsToolSchema>): Promise<ToolResult> {
    try {
      const signals = await contentFeedsApi.getFeedSignals(contentFeedId);

      const formattedColumns = signals.map((signal) => ({
        name: signal.name,
        value: signal.value,
        type: signal.type,
        description: signal.description || '',
        optionalOperators: signal.optionalOperators || [],
      }));

      const response = {
        columns: formattedColumns,
        totalCount: formattedColumns.length,
        contentFeedId,
        instructions:
          formattedColumns.length > 0
            ? `Found ${formattedColumns.length} available columns for content feed configuration.`
            : `No columns found for content feed configuration.`,
      };

      return toolResult(JSON.stringify(response));
    } catch (error) {
      return toolResult(
        `Error retrieving content feed columns: ${
          error instanceof Error ? error.message : 'Unknown error'
        }`,
      );
    }
  }

  return tool({
    name: CampaignSetupAgentToolName.GetContentFeedColumns,
    displayName: 'Getting content feed columns',
    description:
      'Retrieve available columns for a specific content feed to configure content card matching strategy conditions',
    execute,
    inputSchema: getContentFeedColumnsToolSchema,
  });
}

export default getContentFeedColumnsTool;
